<template>
  <label class="base-radio-button">
    <input
      :name="name"
      type="radio"
      v-model="radioButtonValue"
      :value="store"
    >
    <font-awesome-icon
      icon="check-circle"
      class="base-radio-button__icon"
      v-if="radioButtonValue === store"
    />
    <div
      v-else
      class="base-radio-button__empty"
    >
      <div class="base-radio-button__empty-icon" />
    </div>
    <span class="base-radio-button__label">{{ label }}</span>
  </label>
</template>

<script>
export default {
    name: 'BaseRadioButton',
    props: {
        label: { type: String, required: true },
        name: { type: String, required: true },
        store: {
            required: true,
            validator: prop => (typeof prop === 'string' || typeof prop === 'object') || prop === null,
        },
        value: {
            required: true,
            validator: prop => (typeof prop === 'string' || typeof prop === 'object') || prop === null,
        },
    },
    computed: {
        radioButtonValue: {
            get() {
                return this.value;
            },
            set() {
                this.$emit('input', this.store);
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.base-radio-button {
    cursor: pointer;
    height: 40px;
    display: flex;
    align-items: center;

    > input {
        position: absolute;
        top: -9999px;
        left: -9999px;
        visibility: hidden
    }

    &:not(:last-child) {
        margin-right: 20px;
    }

    &__label {
        margin-left: 5px;
        display: inline-block;
    }

    &__icon {
        color: $brand;
    }

    &__empty {
        display: inline-block;
    }
    &__empty-icon {
        width: 14px;
        height: 14px;
        border: 1.5px solid $brand;
        border-radius: 50%;
    }
 }
</style>
